import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import ContrastOutlined from '@mui/icons-material/ContrastOutlined';
import RadioBtnUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import Lock from '@mui/icons-material/Lock';
import LockOpen from '@mui/icons-material/LockOpen';
import GroupsOutlined from '@mui/icons-material/GroupsOutlined';
import BackHandOutlined from '@mui/icons-material/BackHandOutlined';
import SportsOutlined from '@mui/icons-material/SportsOutlined';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import iconData from './kitmanIconData';
import type { IconDataName } from './kitmanIconData';

const KITMAN_ICON_NAMES = {
  ContrastOutlined: 'ContrastOutlined',
  CheckCircleOutline: 'CheckCircleOutline',
  RadioBtnUnchecked: 'RadioBtnUnchecked',
  Lock: 'Lock',
  LockOpen: 'LockOpen',
  GroupsOutlined: 'GroupsOutlined',
  BackHandOutlined: 'BackHandOutlined',
  SportsOutlined: 'SportsOutlined',
  NotificationsNoneIcon: 'NotificationsNoneIcon',
  SimCardDownloadOutlinedIcon: 'SimCardDownloadOutlinedIcon',
};

type KITMAN_ICON_NAME_TYPES = typeof KITMAN_ICON_NAMES;
export type KitmanIconName = keyof KITMAN_ICON_NAME_TYPES;

// Constructs a MUI SvgIcon component using data from iconData
const generateCustomIcon = (
  name: KitmanIconName | IconDataName,
  props: Object
) => {
  const generateIcon = (iconName) => {
    if (!iconName || !iconData) return null;

    // Retrieve corresponding icon data for name passed
    const icon: any = iconData?.find((obj) => {
      return obj.name === iconName;
    });

    // Requested icon exists
    if (icon) {
      const path = icon?.path;

      return (
        // Adding the test id consistent with MUI docs -> https://mui.com/material-ui/icons/#testing
        <SvgIcon {...props} data-testid={`${name}Icon`}>
          <path d={path} />
        </SvgIcon>
      );
    }
    return null;
  };

  return generateIcon(name);
};

const KitmanIcon = ({
  name,
  customIconName,
  ...props
}: {
  name?: KitmanIconName;
  customIconName?: IconDataName;
  style?: object;
  sx?: object;
}) => {
  const icons = {
    ContrastOutlined,
    CheckCircleOutline,
    RadioBtnUnchecked,
    Lock,
    LockOpen,
    GroupsOutlined,
    BackHandOutlined,
    SportsOutlined,
    NotificationsNoneIcon,
    SimCardDownloadOutlinedIcon,
  };

  if (name) {
    const MUIIcon = icons[name];
    if (MUIIcon) {
      return <MUIIcon {...props} />;
    }
  }
  if (customIconName) {
    return generateCustomIcon(customIconName, props);
  }
  return null;
};

export default KitmanIcon;
